import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import LogoutIcon from '@mui/icons-material/Logout';
import LogoVeles from '../../../../../assets/img/Logo Vetorizado Veles Colorido.png';
import { SessionTimer } from './SessionTimer';
import { decodeJwt } from 'jose';

export const Header = () => {
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const [userName, setUserName] = React.useState<string>('USUÁRIO');

  React.useEffect(() => {
    const token = localStorage.getItem('ACCESS_TOKEN');
    if (token) {
      try {
        const decoded = decodeJwt(token);
        if (decoded.Nome) {
          setUserName(decoded.Nome as string);
        } else if (decoded.LoginUsuario) {
          setUserName(decoded.LoginUsuario as string);
        }
      } catch (e) {
        console.error('Error decoding token', e);
      }
    }
  }, []);

  const getInitials = (name: string) => {
    const parts = name.trim().split(' ');
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    handleCloseUserMenu();
    localStorage.removeItem('ACCESS_TOKEN');
    localStorage.removeItem('SESSION_START_TIMESTAMP');
    const loginUrl =
      process.env.REACT_APP_VELES_LOGIN_URL ||
      (process.env.REACT_APP_VELES_MODULES_URL || '').replace('/modulos', '/authentication/login');
    window.location.href = loginUrl;
  };

  return (
    <AppBar 
      position="sticky" 
      className="no-print" 
      sx={{ 
        top: 0, 
        zIndex: (theme) => theme.zIndex.appBar, 
        backgroundColor: '#ffffff', 
        color: 'primary.main', 
        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
        borderBottom: '1px solid #ece7f2'
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box
            component="a"
            href={process.env.REACT_APP_VELES_MODULES_URL}
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              alignItems: 'center',
              textDecoration: 'none',
            }}
          >
            <Box
              component="img"
              src={LogoVeles}
              alt="Veles Logo"
              sx={{
                height: 40,
                objectFit: 'contain',
              }}
            />
            <Box
              sx={{
                width: '1px',
                height: 24,
                backgroundColor: '#e2d9ec',
                mx: 1.5,
              }}
            />
            <Typography
              variant="h6"
              noWrap
              sx={{
                fontWeight: 800,
                color: '#723989',
                fontSize: '1.2rem',
                letterSpacing: '-0.3px',
              }}
            >
              Dossiê Veles
            </Typography>
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
          </Box>
          <Box
            component="a"
            href={process.env.REACT_APP_VELES_MODULES_URL}
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              alignItems: 'center',
              textDecoration: 'none',
            }}
          >
            <Box
              component="img"
              src={LogoVeles}
              alt="Veles Logo"
              sx={{
                height: 32,
                objectFit: 'contain',
              }}
            />
            <Box
              sx={{
                width: '1px',
                height: 20,
                backgroundColor: '#e2d9ec',
                mx: 1,
              }}
            />
            <Typography
              variant="subtitle1"
              noWrap
              sx={{
                fontWeight: 800,
                color: '#723989',
                fontSize: '1.05rem',
                letterSpacing: '-0.3px',
              }}
            >
              Dossiê Veles
            </Typography>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
          </Box>

          <Box sx={{ flexGrow: 0, display: 'flex', alignItems: 'center', gap: 2 }}>
            <SessionTimer />
            <Tooltip title="Opções da Conta">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar sx={{ bgcolor: '#ffffff', color: '#6a1b9a', fontWeight: 'bold', border: '1px solid #000000' }}>
                  {getInitials(userName)}
                </Avatar>
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
              PaperProps={{
                elevation: 3,
                sx: {
                  minWidth: 200,
                  borderRadius: 2,
                  mt: 1.5,
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                },
              }}
            >
              <Box sx={{ px: 2, py: 1.5 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#334155', textAlign: 'center', textTransform: 'uppercase' }}>
                  {userName}
                </Typography>
              </Box>
              <Divider />
              <MenuItem onClick={handleLogout} sx={{ color: '#d32f2f', py: 1.5, mt: 0.5 }}>
                <LogoutIcon sx={{ mr: 1.5, fontSize: 20 }} />
                <Typography variant="body1">Sair</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
